
// ******************
//
// Ver.1.0
// Released on: July 27, 2023
// Phase 1.0
//
// ******************
import Vue from 'vue'
import Title from '@/components/common_new/popup/title.vue'
import { ListNamePopup } from '@/shared/enums'
import { mapGetters } from 'vuex'

export default Vue.extend({
    name: 'PrivacyPolicy',
    components: {
        Title
    },
    computed: {
        ...mapGetters('popup', ['getParamsPopup'])
    },
    methods: {
        closePopup() {
            if (this.getParamsPopup.openFromLoginSupport) {
                this.$store.dispatch('popup/openPopup', {
                    isOpen: true,
                    namePopup: ListNamePopup.LoginSupport
                })
                return
            }
            this.$store.dispatch('popup/hidePopup')
        }
    }
})
